<template>
  <div>
    <PageTitle titleText="お問い合わせ"></PageTitle>
    <section v-if="status == 'edit'">
      <div class="pageCaption contactCaption">
        <div class="contactCaptionDetail">
          個人情報の取扱いに関しては、下記プライバシーポリシーをご参照ください。<br />
          <a href="https://www.hoosiers.co.jp/privacypolicy/" target="_blank"
            >→プライバシーポリシー</a
          >
        </div>
      </div>
      <div class="mainContent-form">
        <dl class="formTable">
          <dt class="formTable_ttl">
            <label for="">マンション名</label>
          </dt>
          <dd class="formTable_data">
            <div class="formTableBox">
              <div class="formTableBox_itemBox">
                <label id="">{{ mansion.name }}</label>
              </div>
            </div>
          </dd>
        </dl>

        <dl class="formTable">
          <dt class="formTable_ttl">
            <label for="">部屋番号</label>
          </dt>
          <dd class="formTable_data">
            <div class="formTableBox">
              <div class="formTableBox_itemBox">
                <label id="">{{ currentUser.roomNo }}</label>
              </div>
            </div>
          </dd>
        </dl>

        <dl class="formTable">
          <dt class="formTable_ttl">
            <span class="icoForm-requir">必須</span>
            <label for="L_NAME">お名前</label>
          </dt>
          <dd class="formTable_data">
            <dl class="formTableBox">
              <dt class="formTableBox_ttl"><label for="L_NAME">姓</label></dt>
              <dd class="formTableBox_itemBox formTableBox_itemBox_name">
                <input
                  type="text"
                  id="L_NAME"
                  maxlength="40"
                  class="m-formBox_input--name u-ime-ja"
                  placeholder="例:田中"
                  name="lastName"
                  v-model.trim="$v.values.sei.$model"
                />
                <div class="error" v-if="!$v.values.sei.required">必須です</div>
              </dd>
              <dt class="formTableBox_ttl"><label for="F_NAME">名</label></dt>
              <dd class="formTableBox_itemBox formTableBox_itemBox_name">
                <input
                  type="text"
                  id="F_NAME"
                  maxlength="40"
                  class="formTableBox_input--name u-ime-ja"
                  placeholder="例:太郎"
                  name="firstName"
                  v-model.trim="$v.values.mei.$model"
                />
                <div class="error" v-if="!$v.values.mei.required">必須です</div>
              </dd>
            </dl>

            <span class="formErr_inline"> </span>
          </dd>
        </dl>

        <dl class="formTable">
          <dt class="formTable_ttl">
            <span class="icoForm-requir">必須</span>
            <label for="L_NAME">ふりがな</label>
          </dt>
          <dd class="formTable_data">
            <dl class="formTableBox">
              <dt class="formTableBox_ttl"><label for="L_NAME">せい</label></dt>
              <dd class="formTableBox_itemBox formTableBox_itemBox_name">
                <input
                  type="text"
                  id="L_NAME"
                  maxlength="40"
                  class="m-formBox_input--name u-ime-ja"
                  placeholder="例:たなか"
                  name="lastName"
                  v-model.trim="$v.values.kanaSei.$model"
                />
                <div class="error" v-if="!$v.values.kanaSei.required">
                  必須です
                </div>
              </dd>
              <dt class="formTableBox_ttl"><label for="F_NAME">めい</label></dt>
              <dd class="formTableBox_itemBox formTableBox_itemBox_name">
                <input
                  type="text"
                  id="F_NAME"
                  maxlength="40"
                  class="formTableBox_input--name u-ime-ja"
                  placeholder="例:たろう"
                  name="firstName"
                  v-model.trim="$v.values.kanaMei.$model"
                />
                <div class="error" v-if="!$v.values.kanaMei.required">
                  必須です
                </div>
              </dd>
            </dl>

            <span class="formErr_inline"> </span>
          </dd>
        </dl>

        <dl class="formTable">
          <dt class="formTable_ttl">
            <span class="icoForm-requir">必須</span>
            <label for="">メールアドレス</label>
          </dt>
          <dd class="formTable_data">
            <div class="formTableBox">
              <div class="formTableBox_itemBox">
                <label id="">{{ values.email }}</label>
                <label id=""
                  ><input
                    type="hidden"
                    id=""
                    class="u-input--w100p u-ime-en"
                    maxlength="128"
                    name=""
                    v-model.trim="$v.values.email.$model"
                /></label>
                <div class="error" v-if="!$v.values.email.required">
                  必須です
                </div>
                <div class="error" v-if="!$v.values.email.email">
                  Emailアドレスを入力してください
                </div>
              </div>
            </div>
          </dd>
        </dl>

        <dl class="formTable">
          <dt class="formTable_ttl">
            <label for="">電話番号</label>
          </dt>
          <dd class="formTable_data">
            <div class="formTableBox">
              <div class="formTableBox_itemBox">
                <label id=""
                  ><input
                    type="text"
                    id=""
                    class="u-input--w100p u-ime-en"
                    maxlength="128"
                    name=""
                    v-model.trim="$v.values.phone.$model"
                /></label>
                <div class="error" v-if="!$v.values.phone.decimal">
                  番号を入力してください
                </div>
                <div class="formTableCautionInner">
                  ※ハイフン（-）なしの半角数字のみをご入力ください。
                </div>
              </div>
            </div>
          </dd>
        </dl>

        <dl class="formTable">
          <dt class="formTable_ttl">
            <label for="">書類送付先等住所</label>
          </dt>
          <dd class="formTable_data">
            <div class="formTableBox">
              <div class="formTableBox_itemBox">
                <label id=""
                  ><input
                    type="text"
                    id=""
                    class="u-input--w100p u-ime-ja"
                    maxlength="512"
                    name=""
                    v-model.trim="$v.values.address.$model"
                /></label>

                <div class="formTableCautionInner">
                  ※郵送物ご依頼等のお問い合わせの場合は、こちらに送付先のご住所を入力してください。（郵便番号の記載もお願いいたします）
                </div>
              </div>
            </div>
          </dd>
        </dl>

        <dl class="formTable">
          <dt class="formTable_ttl">
            <span class="icoForm-requir">必須</span>
            <label for="">お問い合わせ種別</label>
          </dt>
          <dd class="formTable_data">
            <div class="formTableBox">
              <div class="formTableBox_itemBox">
                <select
                  class="select-box"
                  v-model.trim="$v.values.category.$model"
                >
                  <option value="" selected="">選択してください</option>
                  <option
                    v-for="(item, index) in contactCategories"
                    :key="index"
                    v-show="item.status.indexOf(currentUser.status) > -1"
                  >
                    {{ item.name }}
                  </option>
                </select>
                <div class="error" v-if="!$v.values.category.required">
                  必須です
                </div>
              </div>
            </div>
          </dd>
        </dl>

        <dl class="formTable">
          <dt class="formTable_ttl">
            <span class="icoForm-requir">必須</span>
            <label for="">お問い合わせ内容</label>
          </dt>
          <dd class="formTable_data">
            <div class="formTableBox">
              <div class="formTableBox_itemBox">
                <textarea
                  rows="8"
                  class="u-input--w100p u-ime-ja"
                  v-model.trim="$v.values.text.$model"
                ></textarea>

                <div class="error" v-if="!$v.values.text.required">
                  必須です
                </div>
              </div>
            </div>
          </dd>
        </dl>
      </div>
      <div class="c-contact__buttonWrap">
        <a href="javascript:void(0);" @click="onConfirm">
          <Button text="次へ" width="23rem"></Button>
        </a>
      </div>
    </section>

    <section v-if="status == 'confirm'">
      <div class="pageCaption">
        <div class="contactCaptionDetail">
          入力内容をご確認ください。<br />
          よろしければ「送信」ボタンをクリックしてください。
        </div>
      </div>

      <div class="mainContent-form">
        <dl class="formTable">
          <dt class="formTable_ttl">
            <label for="">マンション名</label>
          </dt>
          <dd class="formTable_data">
            <div class="formTableBox">
              <div class="formTableBox_itemBox">
                <label id="">{{ mansion.name }}</label>
              </div>
            </div>
          </dd>
        </dl>

        <dl class="formTable">
          <dt class="formTable_ttl">
            <label for="">部屋番号</label>
          </dt>
          <dd class="formTable_data">
            <div class="formTableBox">
              <div class="formTableBox_itemBox">{{ currentUser.roomNo }}</div>
            </div>
          </dd>
        </dl>

        <dl class="formTable">
          <dt class="formTable_ttl">
            <label for="L_NAME">お名前</label>
          </dt>
          <dd class="formTable_data">
            <div class="formTableBox">
              <div class="formTableBox_itemBox">
                {{ values.sei }} {{ values.mei }}
              </div>
            </div>
          </dd>
        </dl>

        <dl class="formTable">
          <dt class="formTable_ttl">
            <label for="L_NAME">ふりがな</label>
          </dt>
          <dd class="formTable_data">
            <div class="formTableBox">
              <div class="formTableBox_itemBox">
                {{ values.kanaSei }} {{ values.kanaMei }}
              </div>
            </div>
          </dd>
        </dl>

        <dl class="formTable">
          <dt class="formTable_ttl">
            <label for="">メールアドレス</label>
          </dt>
          <dd class="formTable_data">
            <div class="formTableBox">
              <div class="formTableBox_itemBox">{{ values.email }}</div>
            </div>
          </dd>
        </dl>

        <dl class="formTable">
          <dt class="formTable_ttl">
            <label for="">電話番号</label>
          </dt>
          <dd class="formTable_data">
            <div class="formTableBox">
              <div class="formTableBox_itemBox">{{ values.phone }}</div>
            </div>
          </dd>
        </dl>

        <dl class="formTable">
          <dt class="formTable_ttl">
            <label for="">書類送付先等住所</label>
          </dt>
          <dd class="formTable_data">
            <div class="formTableBox">
              <div class="formTableBox_itemBox">
                {{ values.address }}
              </div>
            </div>
          </dd>
        </dl>

        <dl class="formTable">
          <dt class="formTable_ttl">
            <label for="">お問い合わせ種別</label>
          </dt>
          <dd class="formTable_data">
            <div class="formTableBox">
              <div class="formTableBox_itemBox">{{ values.category }}</div>
            </div>
          </dd>
        </dl>

        <dl class="formTable">
          <dt class="formTable_ttl">
            <label for="">お問い合わせ内容</label>
          </dt>
          <dd class="formTable_data">
            <div class="formTableBox">
              <div class="formTableBox_itemBox">
                <pre>{{ values.text }}</pre>
              </div>
            </div>
          </dd>
        </dl>
      </div>
      <div class="c-contact__buttonWrap">
        <a href="javascript:void(0);" @click="status = 'edit'">
          <Button text="戻る" width="23rem"></Button>
        </a>
      </div>
      <div class="c-contact__buttonWrap">
        <a href="javascript:void(0);" @click="onPost">
          <Button text="送信" width="23rem"></Button>
        </a>
      </div>
    </section>

    <section v-else-if="status == 'complete'">
      <div class="pageCaption">
        <div class="contactCaptionDetail">
          お問い合わせを送信しました。<br />
          ご要望・ご質問の内容によっては、返信・回答までのお時間を要することがございます。あらかじめご了承ください。
        </div>
      </div>
      <div class="c-contact__buttonWrap">
        <router-link
          :to="{
            name: 'top',
            params: { mc_code: mcCode },
          }"
        >
          <Button text="トップページへ" width="23rem"></Button>
        </router-link>
      </div>
    </section>
  </div>
</template>

<script>
import { required, email, decimal } from "vuelidate/lib/validators";
import PageTitle from "@/components/PageTitle.vue";
import FormService from "../../services/form.service";
import Button from "@/components/Button.vue";
// import Navi from "../mixin/navi";

export default {
  name: "contact",
  // mixins: [Navi],
  components: {
    PageTitle,
    Button,
  },
  data() {
    return {
      status: "edit",
      contactCategories: [],
      values: {
        sei: "",
        mei: "",
        kanaSei: "",
        kanaMei: "",
        email: "",
        address: "",
        category: "",
        text: "",
        phone: "",
      },
      schema: null,
    };
  },
  validations: {
    values: {
      sei: { required },
      mei: { required },
      kanaSei: { required },
      kanaMei: { required },
      email: { required, email },
      address: {},
      category: { required },
      text: { required },
      phone: { decimal },
    },
  },
  mounted: async function() {
    console.log("+++ contact.mounted");
    await this.$nextTick();
    this.values.email = this.currentUser.email;
    const response = await FormService.getContactCategories();

    //お問合せセレクトボックス__引き渡しについてを追加
    let contactCategoriesArr = [
      ...response.data,
      {
        name: "お引渡しについて",
        status: response.data[0].status,
      },
    ];
    //お問合せセレクトボックス__順番を変更
    const contactCategorieDelivery = contactCategoriesArr.pop();
    const contactCategorieOthers = contactCategoriesArr.pop();
    contactCategoriesArr.push(contactCategorieDelivery);
    contactCategoriesArr.push(contactCategorieOthers);

    this.contactCategories = contactCategoriesArr;

    console.log(this.contactCategories);
  },
  methods: {
    scrollTop: function() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    onConfirm() {
      console.log("onConfirm");
      console.log(this.values);
      this.$v.$touch();
      if (this.$v.$invalid) {
        console.log("ERROR");
      } else {
        this.status = "confirm";
        this.scrollTop();
      }
    },
    async onPost() {
      console.log("onConfirm");
      console.log(this.values);
      this.$v.$touch();
      if (this.$v.$invalid) {
        console.log("ERROR");
      } else {
        this.status = "complete";
        // (category, sei, mei, mansionName,mansion, roomNo, result)
        const result = await FormService.private(
          "contact",
          this.values.sei,
          this.values.mei,
          this.mansion.name,
          this.mansion._id,
          this.currentUser.roomNo,
          this.values,
          false,
        );
        this.scrollTop();
        console.log(result);
      }
    },
  },
};
</script>

<style>
/* @import "/mc/css/mc/contact_layout.css"; */
.flex-wrapper {
  display: flex;
}
</style>
